import { render, staticRenderFns } from "./CreatePaste.vue?vue&type=template&id=32fd7dd4&"
import script from "./CreatePaste.vue?vue&type=script&lang=js&"
export * from "./CreatePaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports